import CustomStarLevelFiveIcon from '@cp/src/assets/icons/CustomStarLevelFiveIcon';
import CustomStarLevelFourIcon from '@cp/src/assets/icons/CustomStarLevelFourIcon';
import CustomStarLevelOneIcon from '@cp/src/assets/icons/CustomStarLevelOneIcon';
import CustomStarLevelThreeIcon from '@cp/src/assets/icons/CustomStarLevelThreeIcon';
import CustomStarLevelTwoIcon from '@cp/src/assets/icons/CustomStarLevelTwoIcon';

export const levelIcons = [
  <CustomStarLevelOneIcon key="level1" />,
  <CustomStarLevelTwoIcon key="level2" />,
  <CustomStarLevelThreeIcon key="level3" />,
  <CustomStarLevelFourIcon key="level4" />,
  <CustomStarLevelFiveIcon key="level5" />
];

export const firstDate = '01';
